import { Link } from 'react-router-dom';
import './MembershipBanner.css';

function MembershipBanner() {
  return (
    <section className="membership-banner">
      <div className="banner-container">
        <div className="banner-image">
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/consulta-giovanile-di-ortona.appspot.com/o/immagini%20sito%2Fentra%20in%20consulta-min.jpg?alt=media&token=a82619d5-9418-4cb1-92c0-ad7c03b86261" 
            alt="Giovani insieme" 
          />
        </div>
        <div className="banner-content">
          <h2>Entra in consulta</h2>
          <p>
           Hai dai 15 ai 35 anni?<br />
            Con noi potrai realizzare eventi per la tua città, organizzare attività di ogni tipo, relazionarti con
            altri ragazzi a livello regionale e le istituzioni ma soprattutto divertirti!<br />
            Allora, cosa aspetti? Compila il form cliccando su Unisciti a noi! e sarai presto ricontattato!
          </p>
          <Link to="/contact" className="cta-button">Unisciti a noi!</Link>
        </div>
      </div>
    </section>
  );
}

export default MembershipBanner;
